module.exports = __webpack_public_path__ + "static/media/COS_KRKA_VETO.3b462b71.webp";